var map = {
	"./AG office(1).jpg": 1582,
	"./AG office.jpg": 4046,
	"./CBT.webp": 7661,
	"./IMG_0581.JPG": 9181,
	"./IMG_1283.JPG": 1303,
	"./IMG_1285.JPG": 3577,
	"./IMG_1315.JPG": 3015,
	"./IMG_1317.JPG": 7349,
	"./IMG_1318.JPG": 6918,
	"./IMG_1322.JPG": 3841,
	"./IMG_1335.JPG": 7933,
	"./IMG_1339.JPG": 3897,
	"./IMG_1340.JPG": 4569,
	"./IMG_1342.JPG": 8603,
	"./IMG_9824.JPG": 6988,
	"./IMG_9836.JPG": 5145,
	"./IMG_9853.JPG": 7178,
	"./IMG_9885.HEIC": 5551,
	"./IMG_9885.jpg": 142,
	"./IMG_9886.HEIC": 6914,
	"./IMG_9886.jpg": 201,
	"./Lyceum logo.jpeg": 8831,
	"./Motivirus 1.jpg": 807,
	"./Motivirus 2.jpg": 1880,
	"./Nawaloka college(1).jpg": 8925,
	"./Nawaloka college.jpg": 9087,
	"./Occupational Therapist.jpeg": 7849,
	"./Occupational therapist 2.jpeg": 7751,
	"./Physiotherapy.JPG": 8078,
	"./Speech therapist.jpeg": 8681,
	"./Thaaru Paranawithana.HEIC": 6633,
	"./Thaaru-Paranawithana.jpg": 9351,
	"./Trainee counselor.jpg": 7328,
	"./back.jpg": 8241,
	"./empower.jpg": 311,
	"./g1.JPG": 57,
	"./g2.JPG": 2062,
	"./g3.JPG": 6251,
	"./g4.JPG": 1464,
	"./image.jpg": 4633,
	"./jjjj.jpg": 2164,
	"./loginbg.png": 7488,
	"./logo-removebg-preview.png": 8518,
	"./logo.jpeg": 6814,
	"./maldives.jpg": 6483,
	"./n1.JPG": 4694,
	"./n2.JPG": 8545,
	"./n3.JPG": 5924
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4082;